module.exports = __webpack_public_path__ + "static/media/gpx_agro_banner.b3bfc262.jpeg";